module.exports = __webpack_public_path__ + "img/Youtube.14d1eddd.png";